import { Component, Inject, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';
import { TsSnackbarService } from 'tsui';
import { AccountService } from 'app/core';
import { Folders } from '../state/actions';
import { Account } from 'app/core/models/account.types';

@Component({
  selector: 'folders-tab-folder-sharing',
  templateUrl: './folder-sharing.component.html',
  styleUrls: ['./folder-sharing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FoldersTabFolderSharingComponent extends OnDestroyMixin implements OnInit {
  account: Account;
  shareLink: boolean = false;
  publicShareUrl: string;
  public message: string = '';
  folderResourceId: number;
  fileResourceId: number;

  private _emailAddresses: string[] = [];
  private generatedUrl = false;
  private _shareUrl: ElementRef;

  @ViewChild('shareUrl') set content(content: ElementRef) {
    this._shareUrl = content;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<FoldersTabFolderSharingComponent>,
    private _snackBar: TsSnackbarService,
    private accountService: AccountService,
    private store: Store,
    private actions: Actions,
  ) {
    super();
    this.account = this.accountService.getCurrentAccount();
  }

  ngOnInit(): void {
    if (this.data.folderResourceId) {
      this.folderResourceId = this.data.folderResourceId;
    }
    if (this.data.fileResourceId) {
      this.fileResourceId = this.data.fileResourceId;
    }

    this.actions
      .pipe(ofActionCompleted(Folders.ShareFile, Folders.ShareFolder))
      .pipe(untilComponentDestroyed(this))
      .subscribe(() => {
        const resource = this.store.selectSnapshot((state) => state.folderState.sharedResult);
        if (this.generatedUrl) {
          this.shareLink = true;
          this.publicShareUrl = resource.url;
          this.copyLinkToClipboard();
          this.generatedUrl = false;
        }
      });
  }

  generateShareableLink(): void {
    this.generatedUrl = true;
    if (this.fileResourceId) {
      this.store.dispatch(new Folders.ShareFile(this.folderResourceId, this.fileResourceId));
    } else if (this.folderResourceId) {
      this.store.dispatch(new Folders.ShareFolder(this.folderResourceId));
    }
  }

  copyLinkToClipboard(): void {
    setTimeout(() => {
      this._shareUrl.nativeElement.select();
      document.execCommand('copy');
      this._snackBar.open('Url copied to clipboard.');
    });
  }

  updateTags(event): void {
    this._emailAddresses = event;
  }

  discard(): void {
    this.matDialogRef.close();
  }

  share(): void {
    if (this._emailAddresses.length > 0) {
      if (this.fileResourceId) {
        this.store
          .dispatch(new Folders.ShareFile(this.folderResourceId, this.fileResourceId))
          .pipe(untilComponentDestroyed(this))
          .subscribe(() => {
            this._snackBar.open('File has been shared.', 'success');
            this.discard();
          });
      } else if (this.folderResourceId) {
        this.store
          .dispatch(new Folders.ShareFolder(this.folderResourceId))
          .pipe(untilComponentDestroyed(this))
          .subscribe(() => {
            this._snackBar.open('Folder has been shared.', 'success');
            this.discard();
          });
      }
    }
  }
}
